// export effects from effects folder here
import { TagsEffects } from "./tags.effect";
import { DocumentEffects } from "./documents.effect";

export const FileEffects = [TagsEffects, DocumentEffects];
